export class FilterDto {
  property: string = '';
  value: string = '';
}